import tools from "../../adScripts/adTools"

const normalizeLanguage = (lang) => {
    const normalized = String(lang || '').toUpperCase()
    return normalized === 'EN' ? 'EN' : 'ES'
}

const initLanguage = () => {
    let lang = tools.getCookie("LANG")
    if(lang == "") {
        lang = (navigator.language || navigator.userLanguage).toUpperCase().split("-")[0]
        const normalized = normalizeLanguage(lang)
        tools.setCookie("LANG", normalized, 30)
        return normalized
    }
    return normalizeLanguage(lang)
}

const state = {
    lang: normalizeLanguage(tools.getCookie("LANG")) || initLanguage()
}
const getters = {
    lang: state => state.lang
}
const mutations = {
    setLang: (state, data) => {
        const normalized = normalizeLanguage(data)
        state.lang = normalized
        tools.setCookie("LANG", normalized, 30)
    }
}
const actions = {
    setLang: (context, data) => {
        context.commit('setLang', data)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
  }